export const Toggle = (props) => {
    const { checked, onChange, label, ...rest } = props;
    return (
        <label className="inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                className="sr-only peer"
                checked={checked}
                onChange={onChange}
                {...rest}
            />
            <div className="relative w-11 h-6 bg-surface-strong rounded-sm peer peer-checked:bg-ink after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-canvas after:border after:border-hairline after:rounded-sm after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full peer-checked:after:border-canvas"></div>
            {label ? <span className="ms-3 text-body-md font-medium text-ink">{label}</span> : null}
        </label>
    );
}
